import axiosInstance from "@/services/axiosInterceptor";

/**
 * Fetches the blogs created by the current user with pagination and search support
 * 
 * @param {Object} params - Query parameters
 * @param {string} [params.search] - Search term for filtering blogs
 * @param {number} [params.limit=10] - Number of blogs per page
 * @param {number} [params.page=1] - Page number
 * @returns {Promise<Object>} - Response containing blogs and pagination metadata
 */
export async function getUserBlogs(params = {}) {
  try {
    const { search = "", limit = 10, page = 1 } = params;
    
    // Build query parameters
    const queryParams = new URLSearchParams();
    if (search) queryParams.append("search", search);
    // if (limit) queryParams.append("limit", limit);
    if (page) queryParams.append("page", page);
    
    const queryString = queryParams.toString();
    const url = `users/blogs${queryString ? `?${queryString}` : ""}`;
    
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching user blogs:", error);
    throw error;
  }
}
